module.exports = __webpack_public_path__ + "img/rural1.04357cc9.png";